import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useRequest } from 'hooks/useRequest'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import DefaultSelect from 'components/formElements/DefaultSelect'
import Spinner from 'components/loader/Spinner'
import { Dropdown } from 'primereact/dropdown'
import Button from 'components/formElements/Button'
import moment from 'moment/moment'
import { MdPersonOff, MdPersonAdd, MdCheckCircle, MdRadioButtonUnchecked } from 'react-icons/md'
import useToast from 'hooks/useToast'
import { getPermission } from 'utils/Auth'
import { userInfo } from 'utils/Auth'
import { Dialog } from 'primereact/dialog'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import { useDispatch, useSelector } from 'react-redux'
import { closeApprovalModal, openApprovalModal } from 'redux/features/general/generalSlice'
import AccordionComp from 'components/accordion/Accordion'
import { DataTable } from 'primereact/datatable'
import Icons from 'assets/icons'
import { Column } from 'primereact/column'
import { InputMask } from 'primereact/inputmask'
import { roleIds, leadManagementStatus } from 'utils/Constants'
import RichEditor from 'components/richEditor/RichEditor'
import { Calendar } from 'primereact/calendar'

const CrmEventModal = ({ event, activityTypes, activityChannels, activityResults, leadManagements, crmContacts, users, onEventChange, onSave, onCancel, isEdit }) => {
    const handleChange = (field, value) => {
        // If isReminder is being set to false, clear reminder fields
        if (field === 'isReminder' && !value) {
            onEventChange({ 
                ...event, 
                [field]: value,
                reminderDateTime: null,
                reminderNote: null,
                reminderUserIds: []
            })
        } else if (field === 'isReminder' && value) {
            // If isReminder is being set to true, set current user as default
            const currentUserId = userInfo ? Number(userInfo['jti']) : null;
            onEventChange({ 
                ...event, 
                [field]: value,
                reminderUserIds: currentUserId ? [currentUserId] : []
            })
        } else {
            onEventChange({ ...event, [field]: value })
        }
    }

    return (
        <div className='w-100'>
            <div className='w-100 d-flex flex-column gap-3'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Aksiyon Tipi *</label>
                            <Dropdown 
                                value={event?.crmManagementActivityTypeId || event?.newCrmManagementActivityTypeName}
                                onChange={e => {
                                    if (!e.originalEvent) return
                                    let isId = Number.isInteger(e.value) && activityTypes.find(t => t.value === e.value)
                                    onEventChange({
                                        ...event,
                                        crmManagementActivityTypeId: isId ? e.value : null,
                                        newCrmManagementActivityTypeName: isId ? null : e.value
                                    })
                                }}
                                onInput={e => {
                                    onEventChange({
                                        ...event,
                                        crmManagementActivityTypeId: null,
                                        newCrmManagementActivityTypeName: e.target.value
                                    })
                                }}
                                options={activityTypes}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Aksiyon tipi seçin veya yazın'
                                filter
                                filterLocale='tr'
                                editable
                                filterInputAutoFocus={false}
                                className='w-100'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Kanal *</label>
                            <Dropdown 
                                value={event?.crmActivityChannelId || event?.newCrmActivityChannelName}
                                onChange={e => {
                                    if (!e.originalEvent) return
                                    let isId = Number.isInteger(e.value) && activityChannels.find(c => c.value === e.value)
                                    onEventChange({
                                        ...event,
                                        crmActivityChannelId: isId ? e.value : null,
                                        newCrmActivityChannelName: isId ? null : e.value
                                    })
                                }}
                                onInput={e => {
                                    onEventChange({
                                        ...event,
                                        crmActivityChannelId: null,
                                        newCrmActivityChannelName: e.target.value
                                    })
                                }}
                                options={activityChannels}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Kanal seçin veya yazın'
                                filter
                                filterLocale='tr'
                                editable
                                filterInputAutoFocus={false}
                                className='w-100'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Etkinlik Sonucu</label>
                            <Dropdown 
                                value={event?.crmActivityResultsId || event?.newCrmActivityResultName}
                                onChange={e => {
                                    if (!e.originalEvent) return
                                    let isId = Number.isInteger(e.value) && activityResults.find(r => r.value === e.value)
                                    onEventChange({
                                        ...event,
                                        crmActivityResultsId: isId ? e.value : null,
                                        newCrmActivityResultName: isId ? null : e.value
                                    })
                                }}
                                onInput={e => {
                                    onEventChange({
                                        ...event,
                                        crmActivityResultsId: null,
                                        newCrmActivityResultName: e.target.value
                                    })
                                }}
                                options={activityResults}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Etkinlik sonucu seçin veya yazın'
                                filter
                                filterLocale='tr'
                                editable
                                filterInputAutoFocus={false}
                                className='w-100'
                            />
                        </div>
                    </div>
                   
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Etkinlik Tarihi *</label>
                            <Calendar
                                value={event?.eventDate ? moment(event.eventDate).toDate() : null}
                                onChange={e => handleChange('eventDate', e.value)}
                                placeholder='Etkinlik tarihini seçin'
                                dateFormat='dd/mm/yy'
                                showTime
                                hourFormat='24'
                                className='w-100'
                                showIcon
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Not *</label>
                            <RichEditor
                                noImage
                                defaultContentState={event?.note || ''}
                                setState={(value) => handleChange('note', value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>İlgili Lead</label>
                            <Dropdown
                                value={event?.leadManagementId || null}
                                onChange={e => handleChange('leadManagementId', e.value)}
                                options={leadManagements || []}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Lead seçin...'
                                filter
                                filterLocale='tr'
                                filterInputAutoFocus={false}
                                className='w-100'
                                showClear
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Kişiler</label>
                            <DefaultSelect
                                isMulti
                                handleChange={(e) => handleChange('crmPersonIds', e ? e.map(person => person.value) : [])}
                                selectOptions={(crmContacts || []).map(contact => ({
                                    label: `${contact.firsName} ${contact.lastName}`,
                                    value: contact.id
                                }))}
                                value={event?.crmPersonIds ? 
                                    (crmContacts || []).filter(contact => event.crmPersonIds.includes(contact.id))
                                        .map(contact => ({ label: `${contact.firsName} ${contact.lastName}`, value: contact.id })) : []}
                                menuPlacement="top"
                                maxMenuHeight={150}
                                isFixed={true}
                                isSearchable={true}
                                isClearable={true}
                            />
                        </div>
                    </div>
                </div>
                {/* Reminder fields only show when creating new event (not editing) */}
                {!isEdit && (
                    <>
                        <div className="row">
                        <div className='col-md-12'>
                                <div className='form-control d-flex flex-row align-items-center'>
                                    <input
                                        type='checkbox'
                                        id='isReminder'
                                        checked={event?.isReminder || false}
                                        onChange={e => handleChange('isReminder', e.target.checked)}
                                        className='me-2'
                                    />
                                    <label htmlFor='isReminder' className='form-control-label'>Hatırlatıcı</label>
                                </div>
                            </div>
                        </div>
                        
                         {/* Conditional Reminder Fields */}
                        {event?.isReminder && (
                            <>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-control'>
                                            <label className='form-control-label'>Hatırlatıcı Tarih ve Saati *</label>
                                            <Calendar
                                                value={event?.reminderDateTime ? moment(event.reminderDateTime).toDate() : null}
                                                onChange={e => handleChange('reminderDateTime', e.value)}
                                                placeholder='Tarih ve saat seçin'
                                                dateFormat='dd/mm/yy'
                                                showTime
                                                hourFormat='24'
                                                className='w-100'
                                                showIcon
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-control'>
                                            <label className='form-control-label'>Hatırlatıcı İlişkili Kişileri *</label>
                                            <DefaultSelect
                                                isMulti
                                                handleChange={(e) => handleChange('reminderUserIds', e ? e.map(u => u.value) : [])}
                                                selectOptions={users}
                                                value={event.reminderUserIds ? 
                                                    users.filter(u => event.reminderUserIds.includes(u.value)) : []}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-control'>
                                            <label className='form-control-label'>Hatırlatıcı Notu *</label>
                                            <textarea
                                                className='default-input'
                                                rows='4'
                                                value={event?.reminderNote || ''}
                                                onChange={e => handleChange('reminderNote', e.target.value)}
                                                placeholder='Hatırlatıcı notu...'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-end gap-3'>
                        <Button className='btn-danger' title='İptal' handleClick={onCancel} />
                        <Button className='btn-success' title={isEdit ? 'Güncelle' : 'Kaydet'} handleClick={onSave} />
                    </div>
                </div>
            </div>
        </div>
    )
}

const CrmPersonModal = ({ person, departments, positions, onPersonChange, onSave, onCancel, isEdit }) => {
    const [emailError, setEmailError] = useState('')
    const [hasTriedToSave, setHasTriedToSave] = useState(false)
    
    const validateEmail = (email) => {
        if (!email) return true // Empty email is valid
        
        // Check for Turkish/special characters first
        const hasTurkishChars = /[çğıöşüÇĞIİÖŞÜ]/.test(email)
        if (hasTurkishChars) {
            return false
        }
        
        // Standard email regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        return emailRegex.test(email)
    }
    
    const handleChange = (field, value) => {
        // Email validation logic
        if (field === 'mail') {
            // Filter Turkish characters immediately as user types
            const filteredValue = value.replace(/[çğıöşüÇĞIİÖŞÜ]/g, '');
            
            // Only show error if user has tried to save before or if they're correcting an invalid email
            if (hasTriedToSave && emailError && filteredValue) {
                if (validateEmail(filteredValue)) {
                    setEmailError('')
                }
            }
            
            onPersonChange({ ...person, [field]: filteredValue })
            return
        }
        
        onPersonChange({ ...person, [field]: value })
    }
    
    const handleSave = () => {
        setHasTriedToSave(true)
        
        // E-posta validasyonu kontrolü
        if (person?.mail && !validateEmail(person.mail)) {
            setEmailError('Geçerli bir e-posta adresi giriniz (Türkçe karakter kullanılamaz)')
            return
        }
        onSave()
    }

    return (
        <div className='w-100'>
            <div className='w-100 d-flex flex-column gap-3'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='form-control-label'>Ad *</label>
                            <input
                                className='default-input'
                                type='text'
                                value={person?.firsName || ''}
                                onChange={e => handleChange('firsName', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='form-control-label'>Soyad *</label>
                            <input
                                className='default-input'
                                type='text'
                                value={person?.lastName || ''}
                                onChange={e => handleChange('lastName', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='form-control-label'>E-posta</label>
                            <input
                                className={`default-input ${emailError ? 'error' : ''}`}
                                type='email'
                                value={person?.mail || ''}
                                onChange={e => handleChange('mail', e.target.value)}
                                placeholder='E-posta girin'
                                autoComplete='email'
                            />
                            {emailError && <div className='error-message'>{emailError}</div>}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='form-control-label'>Telefon</label>
                            <InputMask
                                mask='(999) 999-9999'
                                value={person?.phone || ''}
                                onChange={e => handleChange('phone', e.target.value)}
                                className='default-input'
                                placeholder='(___) ___-____'
                                autoComplete='tel'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>LinkedIn</label>
                            <input
                                className='default-input'
                                type='url'
                                value={person?.linkedin || ''}
                                onChange={e => handleChange('linkedin', e.target.value)}
                                placeholder='https://linkedin.com/in/...'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='form-control-label'>Departman</label>
                            <Dropdown 
                                value={person?.crmCompanyDepartmentId || person?.newCrmCompanyDepartmentName}
                                onChange={e => {
                                    if (!e.originalEvent) return
                                    let isId = Number.isInteger(e.value) && departments.find(d => d.value === e.value)
                                    onPersonChange({
                                        ...person,
                                        crmCompanyDepartmentId: isId ? e.value : null,
                                        newCrmCompanyDepartmentName: isId ? null : e.value
                                    })
                                }}
                                onInput={e => {
                                    onPersonChange({
                                        ...person,
                                        crmCompanyDepartmentId: null,
                                        newCrmCompanyDepartmentName: e.target.value
                                    })
                                }}
                                options={departments}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Departman seçin veya yazın'
                                filter
                                filterLocale='tr'
                                editable
                                filterInputAutoFocus={false}
                                className='w-100'
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='form-control-label'>Pozisyon</label>
                            <Dropdown 
                                value={person?.crmCompanyPositionId || person?.newCrmCompanyPositionName}
                                onChange={e => {
                                    if (!e.originalEvent) return
                                    let isId = Number.isInteger(e.value) && positions.find(p => p.value === e.value)
                                    onPersonChange({
                                        ...person,
                                        crmCompanyPositionId: isId ? e.value : null,
                                        newCrmCompanyPositionName: isId ? null : e.value
                                    })
                                }}
                                onInput={e => {
                                    onPersonChange({
                                        ...person,
                                        crmCompanyPositionId: null,
                                        newCrmCompanyPositionName: e.target.value
                                    })
                                }}
                                options={positions}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Pozisyon seçin veya yazın'
                                filter
                                filterLocale='tr'
                                editable
                                filterInputAutoFocus={false}
                                className='w-100'
                            />
                        </div>
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-end gap-3'>
                        <Button className='btn-danger' title='İptal' handleClick={onCancel} />
                        <Button className='btn-success' title={isEdit ? 'Güncelle' : 'Kaydet'} handleClick={handleSave} />
                    </div>
                </div>
            </div>
        </div>
    )
}

const CrmReminderModal = ({ reminder, crmEvents, users, onReminderChange, onSave, onCancel, isEdit }) => {
    const handleChange = (field, value) => {
        onReminderChange({ ...reminder, [field]: value })
    }
    console.log(crmEvents,'crmEvents')
    return (
        <div className='w-100'>
            <div className='w-100 d-flex flex-column gap-3'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Tarih - Saat *</label>
                            <Calendar
                                value={reminder?.dateAt ? moment(reminder.dateAt).toDate() : null}
                                onChange={e => handleChange('dateAt', e.value)}
                                placeholder='Tarih ve saat seçin'
                                dateFormat='dd/mm/yy'
                                showTime
                                hourFormat='24'
                                className='w-100'
                                showIcon
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>İlgili Kişiler *</label>
                            <DefaultSelect
                                isMulti
                                handleChange={(e) => handleChange('userIds', e ? e.map(u => u.value) : [])}
                                selectOptions={users}
                                value={reminder.userIds ? 
                                    users.filter(u => reminder.userIds.includes(u.value)) : []}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Not</label>
                            <textarea
                                className='default-input'
                                rows='4'
                                value={reminder?.note || ''}
                                onChange={e => handleChange('note', e.target.value)}
                                placeholder='Hatırlatıcı notu...'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Durum</label>
                            <Dropdown
                                value={reminder?.crmReminderStatus ?? 0}
                                onChange={e => handleChange('crmReminderStatus', e.value)}
                                options={[
                                    { label: 'Not Done', value: 0 },
                                    { label: 'Done', value: 1 }
                                ]}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Durum seçin'
                                className='w-100'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>İlişkili Etkinlik</label>
                            <Dropdown
                                value={reminder?.crmManagementEventId || null}
                                onChange={e => handleChange('crmManagementEventId', e.value)}
                                options={crmEvents?.filter(event => event.crmManagementActivityTypeName == 'Arama' || event.crmManagementActivityTypeName == 'Toplantı' || event.crmManagementActivityTypeName == 'Teams Görüşmesi').map(event => {
                                    const eventDate = moment(event?.eventDate).format('DD/MM/YYYY')
                                    const projectName = event?.leadManagement?.projectName || 'İlgili Lead Yok'
                                    const activityType = event?.crmManagementActivityTypeName || event?.newCrmManagementActivityTypeName || 'Etkinlik'
                                    return {
                                        label: `${eventDate} - ${projectName} - ${activityType}`,
                                        value: event.id
                                    }
                                }) || []}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Etkinlik seçin'
                                filter
                                filterLocale='tr'
                                filterInputAutoFocus={false}
                                className='w-100'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-end gap-3'>
                        <Button className='btn-danger' title='İptal' handleClick={onCancel} />
                        <Button className='btn-success' title={isEdit ? 'Güncelle' : 'Kaydet'} handleClick={onSave} />
                    </div>
                </div>
            </div>
        </div>
    )
}

const ChangeCompanyModal = ({ person, companies, onSave, onCancel }) => {
    const [selectedCompany, setSelectedCompany] = useState(null)

    return (
        <div className='w-100'>
            <div className='w-100 d-flex flex-column gap-3'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>
                                <strong>{person?.firsName} {person?.lastName}</strong> adlı kişiyi hangi şirkete taşımak istiyorsunuz?
                            </label>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='form-control-label'>Yeni Şirket *</label>
                            <Dropdown
                                value={selectedCompany}
                                onChange={e => setSelectedCompany(e.value)}
                                options={companies || []}
                                optionLabel='label'
                                optionValue='value'
                                placeholder='Şirket seçin...'
                                filter
                                filterLocale='tr'
                                filterInputAutoFocus={false}
                                className='w-100 dropdown-ellipsis'
                                panelStyle={{ maxWidth: '300px', width: '100%' }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-end gap-3'>
                        <Button className='btn-danger' title='İptal' handleClick={onCancel} />
                        <Button 
                            className='btn-success' 
                            title='Şirketi Değiştir' 
                            handleClick={() => onSave(selectedCompany)} 
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const CrmDetail = () => {
    const { crmId } = useParams()
    const [request] = useRequest()
    const { showToast } = useToast()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { general } = useSelector((state) => state)
    const { approvalModal } = general
    const [crmData, setCrmData] = useState()
    const [crmTitle, setCrmTitle] = useState()
    const [sectors, setSectors] = useState([])
    const [accountManagers, setAccountManagers] = useState([])
    const [users, setUsers] = useState([])
    const [crmEvents, setCrmEvents] = useState([])
    const [upsertCrmEventModal, setUpsertCrmEventModal] = useState({ open: false, id: null, event: {} })
    const [activityTypes, setActivityTypes] = useState([])
    const [activityChannels, setActivityChannels] = useState([])
    const [activityResults, setActivityResults] = useState([])
    const [crmContacts, setCrmContacts] = useState([])
    const [upsertCrmContactModal, setUpsertCrmContactModal] = useState({ open: false, id: null, person: {} })
    const [departments, setDepartments] = useState([])
    const [positions, setPositions] = useState([])
    const [leadManagements, setLeadManagements] = useState([])
    const [crmReminders, setCrmReminders] = useState([])
    const [upsertCrmReminderModal, setUpsertCrmReminderModal] = useState({ open: false, id: null, reminder: {} })
    const [crmLeads, setCrmLeads] = useState([])
    const [changeCompanyModal, setChangeCompanyModal] = useState({ open: false, person: null })
    const [allCrmCompanies, setAllCrmCompanies] = useState([])
    console.log(upsertCrmReminderModal,'upsertCrmReminderModal')
    // Filtre state'leri
    const [contactFilters, setContactFilters] = useState({
        name: '',
        department: null,
        position: null
    })
    const [filteredCrmContacts, setFilteredCrmContacts] = useState([])
    
    // Etkinlik filtre state'leri
    const [eventFilters, setEventFilters] = useState({
        activityType: null,
        channel: null,
        result: null,
        lead: null,
        accountManager: [],
        dateRange: null
    })
    const [filteredCrmEvents, setFilteredCrmEvents] = useState([])
    
    // Hatırlatıcı filtre state'leri
    const [reminderFilters, setReminderFilters] = useState({
        dateRange: null,
        status: null
    })
    const [filteredCrmReminders, setFilteredCrmReminders] = useState([])

    useEffect(() => {
        getCrmData()
        getInitialData()
        getCrmContacts()
        getCrmReminders()
        getAllCrmCompanies()
    }, [crmId])
    useEffect(()=>{
        if(crmData?.crmCompanyId){
            getCrmLeads()
        }
    },[crmData])
    const getCrmData = () => {
        request('/CrmManagement/GetCrmManagementById', { method: 'GET', params: { id: crmId } })
            .then(res => {
                if (res.data.ok) {
                    setCrmData(res.data.result)
                    setCrmTitle(res.data.result.newCrmCompanyName)
                } else {
                    showToast('CRM Kaydı Bulunamadı', 'error')
                }
            })
            .catch(error => {
                showToast('CRM Kaydı yüklenirken hata oluştu', 'error')
                console.error('Error fetching CRM data:', error)
            })
    }

    const getInitialData = () => {
        // Get sectors from API
        request('/CrmManagement/GetCrmCompanySectors', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setSectors(res.data.result.map((s) => ({ label: s.name, value: s.id })))
            }
        }).catch(error => {
            console.error('Error fetching sectors:', error)
        })

        // Get account managers
        request('/Account/GetAllUsers', { method: 'GET',params: {
            isDeleteFilter: true
        } }).then((res) => {
            if (res.data.ok) {
                setAccountManagers(res.data.result.filter(r => r.roles.map(r => r.id).includes(roleIds.accountManager))
                    .map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.id })))
                setUsers(res.data.result.map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.id,roles:u.roles })))
            }
        }).catch(error => {
            console.error('Error fetching account managers:', error)
        })

        // Get departments from API
        request('/CrmManagement/GetCrmCompanyDepartments', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setDepartments(res.data.result.map((d) => ({ label: d.name, value: d.id })))
            }
        }).catch(error => {
            console.error('Error fetching departments:', error)
        })

        // Get positions from API
        request('/CrmManagement/GetCrmCompanyPositions', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setPositions(res.data.result.map((p) => ({ label: p.name, value: p.id })))
            }
        }).catch(error => {
            console.error('Error fetching positions:', error)
        })

        // Get activity types, channels, and results for events
        request('/CrmManagement/GetCrmManagementEventTypes', { method: 'GET' })
            .then(res => {
                if (res.data.ok) {
                    setActivityTypes(res.data.result.map(type => ({ label: type.name, value: type.id })))
                }
            }).catch(error => {
                console.error('Error fetching activity types:', error)
            })

        request('/CrmManagement/GetCrmActivityChannels', { method: 'GET' })
            .then(res => {
                if (res.data.ok) {
                    setActivityChannels(res.data.result.map(channel => ({ label: channel.name, value: channel.id })))
                }
            }).catch(error => {
                console.error('Error fetching activity channels:', error)
            })

        request('/CrmManagement/GetCrmActivityResults', { method: 'GET' })
            .then(res => {
                if (res.data.ok) {
                    setActivityResults(res.data.result.map(result => ({ label: result.name, value: result.id })))
                }
            }).catch(error => {
                console.error('Error fetching activity results:', error)
            })

        // Initialize events
        getCrmEvents()
    }

   

    const handleChange = (e, name) => {
        if (name) {
            setCrmData((prev) => ({ ...prev, [name]: e }))
        } else {
            setCrmData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSave = () => {
        if (!crmData?.newCrmCompanyName) {
            showToast('Kurumsal Adı Girin', 'error')
            return
        }

        if (!crmData?.crmCompanySectorId && !crmData?.crmCompanySectorName) {
            showToast('Sektör Seçin', 'error')
            return
        }

        if (!crmData?.accountManagerUserIds || crmData?.accountManagerUserIds.length === 0) {
            showToast('Account Manager Seçin', 'error')
            return
        }

        const postData = {
            id: crmData.id,
            crmCompanyId: crmData.crmCompanyId || 0,
            newCrmCompanyName: crmData.newCrmCompanyName,
            crmCompanySectorId: crmData.crmCompanySectorId || 0,
            newCrmCompanySectorName: crmData.crmCompanySectorName || "",
            serviceProvider: crmData.serviceProvider ?? 0,
            webSiteUrl: crmData.webSiteUrl || "",
            status: crmData.status,
            accountManagerUserIds: crmData.accountManagerUserIds
        }

        request('/CrmManagement/UpsertCrmManagement', {
            method: 'POST',
            data: postData
        }).then((res) => {
            if (res.data.ok) {
                showToast('CRM Kaydı Güncellendi', 'success')
                getCrmData() // Refresh data
            } else {
                showToast('Güncelleme sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Güncelleme sırasında hata oluştu', 'error')
            console.error('Error updating CRM data:', error)
        })
    }

    const handleDelete = () => {
        dispatch(openApprovalModal({ open: true, content: 'CRM kaydını silmek istediğinize emin misiniz?', requestType: 'delete' }))
    }

 

    const handleApprovalModalApproved = () => {
        if (approvalModal.requestType === 'delete') {
            handleCloseApprovalModal()
            handleDeleteCrmManagement()
            return
        }

        if (approvalModal.requestType === 'archive') {
            // For now, just toggle archive status and show success message
            setCrmData(prev => ({ ...prev, isArchived: !prev.isArchived }))
            handleCloseApprovalModal()
            showToast(crmData.isArchived ? 'CRM Kaydı Arşivden Çıkarıldı' : 'CRM Kaydı Arşivlendi', 'success')
            return
        }

        if (approvalModal.requestType === 'personStatus') {
            handleCloseApprovalModal()
            handleUpdatePersonStatus(approvalModal.personData, approvalModal.newStatus)
            return
        }

        if (approvalModal.requestType === 'reminderStatus') {
            handleCloseApprovalModal()
            handleUpdateReminderStatus({...approvalModal.reminderData,userIds:approvalModal.reminderData.users?.map(u => u.id) || []}, approvalModal.newStatus)
            return
        }

        if (approvalModal.deleteEndpoint) {
            handleCloseApprovalModal()
            switch (approvalModal.tableForDelete) {
                case 'events':
                    handleDeleteCrmEvent(approvalModal.deleteData)
                    break
                case 'contacts':
                    handleDeleteCrmPerson(approvalModal.deleteData)
                    break
                case 'reminders':
                    handleDeleteCrmReminder(approvalModal.deleteData)
                    break
            }
        }
    }

    const handleCloseApprovalModal = () => {
        dispatch(closeApprovalModal())
    }

    const deleteButton = (deleteData, deleteEndpoint, tableForDelete) => {
        return (
            <Icons.deleteNotFill
                onClick={() => {
                    handleDeleteRow(deleteData, deleteEndpoint, tableForDelete)
                }}
                size={20}
                className='text-danger cursor-pointer'
            />
        )
    }

    const handleDeleteRow = (deleteData, deleteEndpoint, tableForDelete) => {
        dispatch(openApprovalModal({ open: true, content: 'Silmek istedğinize emin misiniz?', deleteData, deleteEndpoint, tableForDelete }))
    }

    const getCrmEvents = () => {
        request('/CrmManagement/GetCrmManagementEvents', { method: 'GET', params: { crmManagementId: crmId } })
            .then(res => {
                if (res.data.ok) {
                    const events = res.data.result
                    // Her event için kişileri getir
                    const eventPromises = events.map(event => 
                        getCrmEventPersons(event.id).then(persons => ({
                            ...event,
                            crmPersonIds: persons.map(p => p.crmPersonId)
                        }))
                    )
                    
                    Promise.all(eventPromises)
                        .then(eventsWithPersons => {
                            setCrmEvents(eventsWithPersons)
                        })
                        .catch(error => {
                            console.error('Error fetching event persons:', error)
                            setCrmEvents(events) // Fallback: kişiler olmadan göster
                        })
                } else {
                    showToast('Etkinlikler yüklenirken hata oluştu', 'error')
                }
            })
            .catch(error => {
                console.error('Error fetching CRM events:', error)
                showToast('Etkinlikler yüklenirken hata oluştu', 'error')
            })
    }

    const getCrmEventPersons = (crmManagementEventId) => {
        return request('/CrmManagement/GetAllCrmEventToPersons', { 
            method: 'GET', 
            params: { crmManagementEventId } 
        })
        .then(res => {
            if (res.data.ok) {
                return res.data.result
            }
            return []
        })
        .catch(error => {
            console.error('Error fetching event persons:', error)
            return []
        })
    }

    const getCrmContacts = () => {
        request('/CrmManagement/GetAllCrmPersons', { method: 'GET', params: { crmId: crmId } })
            .then(res => {
                if (res.data.ok) {
                    setCrmContacts(res.data.result)
                } else {
                    showToast('Kişiler yüklenirken hata oluştu', 'error')
                }
            })
            .catch(error => {
                console.error('Error fetching CRM contacts:', error)
            })
    }

    // Filtreleme fonksiyonu
    const filterContacts = () => {
        let filtered = [...crmContacts]

        // Ad Soyad filtresi
        if (contactFilters.name) {
            filtered = filtered.filter(contact => 
                `${contact.firsName} ${contact.lastName}`.toLowerCase().includes(contactFilters.name.toLowerCase())
            )
        }

        // Departman filtresi
        if (contactFilters.department) {
            filtered = filtered.filter(contact => 
                contact.crmCompanyDepartmentId === contactFilters.department.value
            )
        }

        // Pozisyon filtresi
        if (contactFilters.position) {
            filtered = filtered.filter(contact => 
                contact.crmCompanyPositionId === contactFilters.position.value
            )
        }

        setFilteredCrmContacts(filtered)
    }

    // Filtre değişikliklerini dinle
    useEffect(() => {
        filterContacts()
    }, [crmContacts, contactFilters])

    // Etkinlik filtreleme fonksiyonu
    const filterEvents = () => {
        let filtered = [...crmEvents]

        // Aksiyon Tipi filtresi
        if (eventFilters.activityType) {
            filtered = filtered.filter(event => 
                event.crmManagementActivityTypeId === eventFilters.activityType.value ||
                event.newCrmManagementActivityTypeName === eventFilters.activityType.label
            )
        }

        // Kanal filtresi
        if (eventFilters.channel) {
            filtered = filtered.filter(event => 
                event.crmActivityChannelId === eventFilters.channel.value ||
                event.newCrmActivityChannelName === eventFilters.channel.label
            )
        }

        // Sonuç filtresi
        if (eventFilters.result) {
            filtered = filtered.filter(event => 
                event.crmActivityResultsId === eventFilters.result.value ||
                event.newCrmActivityResultName === eventFilters.result.label
            )
        }

        // İlgili Lead filtresi
        if (eventFilters.lead) {
            filtered = filtered.filter(event => 
                event.leadManagementId === eventFilters.lead.value
            )
        }

        // Account Manager filtresi
        if (eventFilters.accountManager && eventFilters.accountManager.length > 0) {
            const amIds = eventFilters.accountManager.map(am => am.value)
            filtered = filtered.filter(event => {
                if (event.crmPersonIds && event.crmPersonIds.length > 0) {
                    return event.crmPersonIds.some(personId => amIds.includes(personId))
                }
                return false
            })
        }

        // Tarih aralığı filtresi
        if (eventFilters.dateRange && eventFilters.dateRange.length === 2) {
            const [startDate, endDate] = eventFilters.dateRange
            
            // startDate ve endDate null kontrolü
            if (!startDate || !endDate) {
                return
            }
            
            filtered = filtered.filter(event => {
                if (event.eventDate) {
                    const eventDate = new Date(event.eventDate)
                    
                    // Date objesi geçerli mi kontrol et
                    if (isNaN(eventDate.getTime())) {
                        return false
                    }
                    
                    // Sadece tarih kısmını karşılaştır (saat kısmını göz ardı et)
                    const eventDateOnly = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate())
                    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
                    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
                    
                    return eventDateOnly >= startDateOnly && eventDateOnly <= endDateOnly
                }
                return false
            })
        }

        setFilteredCrmEvents(filtered)
    }

    // Etkinlik filtre değişikliklerini dinle
    useEffect(() => {
        filterEvents()
    }, [crmEvents, eventFilters])

    // Hatırlatıcı filtreleme fonksiyonu
    const filterReminders = () => {
        let filtered = [...crmReminders]

        // Tarih aralığı filtresi
        if (reminderFilters.dateRange && reminderFilters.dateRange.length === 2) {
            const [startDate, endDate] = reminderFilters.dateRange
            
            // startDate ve endDate null kontrolü
            if (!startDate || !endDate) {
                return
            }
            
            filtered = filtered.filter(reminder => {
                if (reminder.dateAt) {
                    const reminderDate = new Date(reminder.dateAt)
                    
                    // Date objesi geçerli mi kontrol et
                    if (isNaN(reminderDate.getTime())) {
                        return false
                    }
                    
                    // Sadece tarih kısmını karşılaştır (saat kısmını göz ardı et)
                    const reminderDateOnly = new Date(reminderDate.getFullYear(), reminderDate.getMonth(), reminderDate.getDate())
                    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
                    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
                    
                    return reminderDateOnly >= startDateOnly && reminderDateOnly <= endDateOnly
                }
                return false
            })
        }

        // Durum filtresi
        if (reminderFilters.status) {
            filtered = filtered.filter(reminder => 
                reminder.crmReminderStatus === reminderFilters.status.value
            )
        }

        setFilteredCrmReminders(filtered)
    }

    // Hatırlatıcı filtre değişikliklerini dinle
    useEffect(() => {
        filterReminders()
    }, [crmReminders, reminderFilters])


    const getCrmReminders = () => {
        request('/CrmManagement/GetAllCrmReminders', { method: 'GET', params: { crmManagementId: crmId } })
            .then(res => {
                if (res.data.ok) {
                    setCrmReminders(res.data.result)
                } else {
                    showToast('Hatırlatıcılar yüklenirken hata oluştu', 'error')
                }
            })
            .catch(error => {
                console.error('Error fetching CRM reminders:', error)
                showToast('Hatırlatıcılar yüklenirken hata oluştu', 'error')
            })
    }

    const getCrmLeads = () => {
        request('/CrmManagement/GetLeadsByCrmCompanyId', { method: 'GET', params: { crmCompanyId: crmData?.crmCompanyId } })
            .then(res => {
                if (res.data.ok) {
                    setCrmLeads(res.data.result)
                    const formattedLeads = res.data.result.map(lead => ({
                        label: `${lead.projectName}`,
                        value: lead.id
                    }))
                    setLeadManagements(formattedLeads)
                } else {
                    showToast('Leads yüklenirken hata oluştu', 'error')
                }
            })
            .catch(error => {
                console.error('Error fetching CRM leads:', error)
                showToast('Leads yüklenirken hata oluştu', 'error')
            })
    }

    const getAllCrmCompanies = () => {
        request('/CrmManagement/GetAllCrmForDirectoryCompanies', { method: 'GET' })
            .then(res => {
                if (res.data.ok) {
                    const formattedCompanies = res.data.result.map(company => ({
                        label: company.newCrmCompanyName || company.name,
                        value: company.id
                    }))
                    setAllCrmCompanies(formattedCompanies)
                } else {
                    showToast('Şirketler yüklenirken hata oluştu', 'error')
                }
            })
            .catch(error => {
                console.error('Error fetching CRM companies:', error)
                showToast('Şirketler yüklenirken hata oluştu', 'error')
            })
    }

    const handleAddCrmReminder = () => {
        if (!upsertCrmReminderModal.reminder?.dateAt) {
            showToast('Tarih-Saat Seçin', 'error')
            return
        }
        if (!upsertCrmReminderModal.reminder?.userIds || upsertCrmReminderModal.reminder.userIds.length === 0) {
            showToast('En az bir kişi seçin', 'error')
            return
        }

        const postData = {
            id: upsertCrmReminderModal.id || 0,
            dateAt: upsertCrmReminderModal.reminder.dateAt ? 
                moment(upsertCrmReminderModal.reminder.dateAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            note: upsertCrmReminderModal.reminder.note || "",
            crmReminderStatus: upsertCrmReminderModal.reminder.crmReminderStatus ?? 0,
            crmManagementEventId: upsertCrmReminderModal.reminder.crmManagementEventId || null,
            userIds: upsertCrmReminderModal.reminder.userIds,
            crmManagementId: parseInt(crmId)
        }

        request('/CrmManagement/UpsertCrmReminder', {
            method: 'POST',
            data: postData
        }).then((res) => {
            if (res.data.ok) {
                showToast(upsertCrmReminderModal.id ? 'Hatırlatıcı Güncellendi' : 'Hatırlatıcı Eklendi', 'success')
                setUpsertCrmReminderModal({ open: false, id: null, reminder: {} })
                getCrmReminders() // Refresh reminders
            } else {
                showToast('İşlem sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('İşlem sırasında hata oluştu', 'error')
            console.error('Error saving CRM reminder:', error)
        })
    }

    const handleDeleteCrmReminder = (reminderData) => {

        request('/CrmManagement/DeleteCrmReminder', {
            method: 'DELETE',
            params: { id: reminderData.id }
        }).then((res) => {
            if (res.data.ok) {
                showToast('Hatırlatıcı Silindi', 'success')
                getCrmReminders() // Refresh reminders
            } else {
                showToast('Silme işlemi sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Silme işlemi sırasında hata oluştu', 'error')
            console.error('Error deleting CRM reminder:', error)
        })
    }

    const handleDeleteCrmEvent = (eventData) => {
        const deleteData = {
            id: eventData.id,
            crmManagementId: parseInt(crmId),
            crmManagementActivityTypeId: eventData.crmManagementActivityTypeId || 0,
            newCrmManagementActivityTypeName: eventData.newCrmManagementActivityTypeName || "",
            crmActivityChannelId: eventData.crmActivityChannelId || 0,
            newCrmActivityChannelName: eventData.newCrmActivityChannelName || "",
            crmActivityResultsId: eventData.crmActivityResultsId || 0,
            newCrmActivityResultName: eventData.newCrmActivityResultName || "",
            note: eventData.note || "",
            isReminder: eventData.isReminder || false,
            leadManagementId: eventData.leadManagementId || 0,
            personIds: eventData.crmPersonIds || [],
            reminderDateAt: eventData.reminderDateAt || null,
            reminderNote: eventData.reminderNote || ""
        }

        request('/CrmManagement/DeleteCrmManagementEvent', {
            method: 'DELETE',
            data: deleteData
        }).then((res) => {
            if (res.data.ok) {
                showToast('Etkinlik Silindi', 'success')
                getCrmEvents() // Refresh events
                getCrmReminders() // Refresh reminders in case deleted event had reminders
            } else {
                showToast('Silme işlemi sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Silme işlemi sırasında hata oluştu', 'error')
            console.error('Error deleting CRM event:', error)
        })
    }

    const handleDeleteCrmPerson = (personData) => {
        const deleteData = {
            id: personData.id,
            firsName: personData.firsName || "",
            lastName: personData.lastName || "",
            phone: personData.phone || "",
            mail: personData.mail || "",
            linkedin: personData.linkedin || "",
            crmPersonStatus: personData.crmPersonStatus || 0,
            crmManagementId: parseInt(crmId),
            crmCompanyDepartmentId: personData.crmCompanyDepartmentId || null,
            newCrmCompanyDepartmentName: personData.newCrmCompanyDepartmentName || "",
            crmCompanyPositionId: personData.crmCompanyPositionId || null,
            newCrmCompanyPositionName: personData.newCrmCompanyPositionName || ""
        }

        request('/CrmManagement/DeleteCrmPerson', {
            method: 'DELETE',
            data: deleteData
        }).then((res) => {
            if (res.data.ok) {
                showToast('Kişi Silindi', 'success')
                getCrmContacts() // Refresh contacts
            } else {
                showToast('Silme işlemi sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Silme işlemi sırasında hata oluştu', 'error')
            console.error('Error deleting CRM person:', error)
        })
    }

    const handleChangeCompany = (newCompanyId) => {
        if (!newCompanyId) {
            showToast('Şirket Seçin', 'error')
            return
        }
        
        const transferData = {
            personId: changeCompanyModal.person.id,
            targetCrmId: newCompanyId
        }

        request('/CrmManagement/PersonTransfer', {
            method: 'POST',
            data: transferData
        }).then((res) => {
            console.log(res)
            if (res.data.ok) {
                showToast('Kişi şirketi başarıyla değiştirildi', 'success')
                setChangeCompanyModal({ open: false, person: null })
                getCrmContacts() // Refresh contacts list
            } else {
                if(res.data.metadata.message) {
                    showToast(res.data.metadata.message, 'error')
                } else {
                    showToast('Şirket değiştirme işlemi sırasında hata oluştu', 'error')
                }
            }
        }).catch(error => {
            showToast('Şirket değiştirme işlemi sırasında hata oluştu', 'error')
            console.error('Error transferring person:', error)
        })
    }

    const handlePersonStatusChange = (person, newStatus) => {
        const statusMessage = newStatus === 1 ? 'işten ayrıldı' : 'işten ayrılma durumu iptal edilsin'
        const confirmMessage = `${person.firsName} ${person.lastName} kişisi ${statusMessage} olarak güncellensin mi?`
        
        dispatch(openApprovalModal({ 
            open: true, 
            content: confirmMessage, 
            requestType: 'personStatus',
            personData: person,
            newStatus: newStatus
        }))
    }

    const handleUpdatePersonStatus = (person, newStatus) => {
        const updateData = {
            id: person.id,
            firsName: person.firsName || "",
            lastName: person.lastName || "",
            phone: person.phone || "",
            mail: person.mail || "",
            linkedin: person.linkedin || "",
            crmPersonStatus: newStatus === 1 ? 1 : null,
            crmManagementId: parseInt(crmId),
            crmCompanyDepartmentId: person.crmCompanyDepartmentId || 0,
            newCrmCompanyDepartmentName: person.newCrmCompanyDepartmentName || "",
            crmCompanyPositionId: person.crmCompanyPositionId || 0,
            newCrmCompanyPositionName: person.newCrmCompanyPositionName || ""
        }

        request('/CrmManagement/UpsertCrmPerson', {
            method: 'POST',
            data: updateData
        }).then((res) => {
            if (res.data.ok) {
                const successMessage = newStatus === 1 ? 'Kişi işten ayrıldı olarak güncellendi' : 'Kişi işten ayrılma durumu iptal edildi'
                showToast(successMessage, 'success')
                getCrmContacts() // Refresh contacts list
            } else {
                showToast('Durum güncelleme sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Durum güncelleme sırasında hata oluştu', 'error')
            console.error('Error updating person status:', error)
        })
    }

    const handleReminderStatusChange = (reminder, newStatus) => {
        const statusMessage = newStatus === 1 ? 'Done olarak işaretlensin' : 'Not Done olarak işaretlensin'
        const confirmMessage = `Hatırlatıcı ${statusMessage} mi?`
        console.log(reminder,'reminder')
        dispatch(openApprovalModal({ 
            open: true, 
            content: confirmMessage, 
            requestType: 'reminderStatus',
            reminderData: reminder,
            newStatus: newStatus
        }))
    }

    const handleUpdateReminderStatus = (reminder, newStatus) => {
        const updateData = {
            id: reminder.id,
            dateAt: reminder.dateAt,
            note: reminder.note || "",
            crmReminderStatus: newStatus,
            crmManagementEventId: reminder.crmManagementEventId,
            crmManagementId: parseInt(crmId),
            userIds:reminder.userIds || []
        }

        request('/CrmManagement/UpsertCrmReminder', {
            method: 'POST',
            data: updateData
        }).then((res) => {
            if (res.data.ok) {
                const successMessage = newStatus === 1 ? 'Hatırlatıcı Done olarak güncellendi' : 'Hatırlatıcı Not Done olarak güncellendi'
                showToast(successMessage, 'success')
                getCrmReminders() // Refresh reminders list
            } else {
                showToast('Durum güncelleme sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Durum güncelleme sırasında hata oluştu', 'error')
            console.error('Error updating reminder status:', error)
        })
    }

    const handleDeleteCrmManagement = () => {
        const deleteData = {
            id: crmData.id,
            crmCompanyId: crmData.crmCompanyId || 0,
            newCrmCompanyName: crmData.newCrmCompanyName || "",
            crmCompanySectorId: crmData.crmCompanySectorId || 0,
            newCrmCompanySectorName: crmData.newCrmCompanySectorName || "",
            serviceProvider: crmData.serviceProvider ?? 0,
            webSiteUrl: crmData.webSiteUrl || "",
            status: crmData.status || 0,
            accountManagerUserIds: crmData.accountManagerUserIds || []
        }

        request('/CrmManagement/DeleteCrmManagement', {
            method: 'DELETE',
            data: deleteData
        }).then((res) => {
            if (res.data.ok) {
                showToast('CRM Kaydı Silindi', 'success')
                navigate('/crm-management')
            } else {
                showToast('Silme işlemi sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('Silme işlemi sırasında hata oluştu', 'error')
            console.error('Error deleting CRM management:', error)
        })
    }

    const handleAddCrmPerson = () => {
        if (!upsertCrmContactModal.person?.firsName) {
            showToast('Ad Girin', 'error')
            return
        }
        if (!upsertCrmContactModal.person?.lastName) {
            showToast('Soyad Girin', 'error')
            return
        }

        const postData = {
            id: upsertCrmContactModal.person.id || 0,
            firsName: upsertCrmContactModal.person.firsName,
            lastName: upsertCrmContactModal.person.lastName,
            phone: upsertCrmContactModal.person.phone || "",
            mail: upsertCrmContactModal.person.mail,
            linkedin: upsertCrmContactModal.person.linkedin || "",
            crmPersonStatus: upsertCrmContactModal.person.crmPersonStatus || null,
            crmManagementId: parseInt(crmId),
            crmCompanyDepartmentId: upsertCrmContactModal.person.crmCompanyDepartmentId || null,
            newCrmCompanyDepartmentName: upsertCrmContactModal.person.newCrmCompanyDepartmentName || "",
            crmCompanyPositionId: upsertCrmContactModal.person.crmCompanyPositionId || null,
            newCrmCompanyPositionName: upsertCrmContactModal.person.newCrmCompanyPositionName || ""
        }

        request('/CrmManagement/UpsertCrmPerson', {
            method: 'POST',
            data: postData
        }).then((res) => {
            if (res.data.ok) {
                showToast(upsertCrmContactModal.id ? 'Kişi Güncellendi' : 'Kişi Eklendi', 'success')
                setUpsertCrmContactModal({ open: false, id: null, person: {} })
                getCrmContacts() // Refresh contacts
                
                // Departman ve pozisyon listelerini tekrar çek
                request('/CrmManagement/GetCrmCompanyDepartments', { method: 'GET' })
                    .then(deptRes => {
                        if (deptRes.data.ok) {
                            setDepartments(deptRes.data.result.map(dept => ({ label: dept.name, value: dept.id })))
                        }
                    })
                request('/CrmManagement/GetCrmCompanyPositions', { method: 'GET' })
                    .then(posRes => {
                        if (posRes.data.ok) {
                            setPositions(posRes.data.result.map(pos => ({ label: pos.name, value: pos.id })))
                        }
                    })
            } else {
                showToast('İşlem sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('İşlem sırasında hata oluştu', 'error')
            console.error('Error saving CRM person:', error)
        })
    }

    const handleAddCrmEvent = () => {
        if (!upsertCrmEventModal.event?.eventDate) {
            showToast('Etkinlik Tarihi Seçin', 'error')
            return
        }
        if (!upsertCrmEventModal.event?.crmManagementActivityTypeId && !upsertCrmEventModal.event?.newCrmManagementActivityTypeName) {
            showToast('Aksiyon Tipi Seçin veya Girin', 'error')
            return
        }
        if (!upsertCrmEventModal.event?.crmActivityChannelId && !upsertCrmEventModal.event?.newCrmActivityChannelName) {
            showToast('Kanal Seçin veya Girin', 'error')
            return
        }
        if (!upsertCrmEventModal.event?.note || upsertCrmEventModal.event?.note.trim() === '') {
            showToast('Not Girin', 'error')
            return
        }
        // Hatırlatıcı seçiliyse tarih ve not zorunlu (sadece yeni etkinlik eklerken)
        if (!upsertCrmEventModal.id && upsertCrmEventModal.event?.isReminder) {
            if (!upsertCrmEventModal.event?.reminderDateTime) {
                showToast('Hatırlatıcı Tarih ve Saati Seçin', 'error')
                return
            }
            if (!upsertCrmEventModal.event?.reminderUserIds || upsertCrmEventModal.event.reminderUserIds.length === 0) {
                showToast('Hatırlatıcı İlişkili Kişileri Seçin', 'error')
                return
            }
            if (!upsertCrmEventModal.event?.reminderNote || upsertCrmEventModal.event?.reminderNote.trim() === '') {
                showToast('Hatırlatıcı Notu Girin', 'error')
                return
            }
        }

        const postData = {
            id: upsertCrmEventModal.id || 0,
            crmManagementId: parseInt(crmId),
            crmManagementActivityTypeId: upsertCrmEventModal.event.crmManagementActivityTypeId || 0,
            newCrmManagementActivityTypeName: upsertCrmEventModal.event.newCrmManagementActivityTypeName || "",
            crmActivityChannelId: upsertCrmEventModal.event.crmActivityChannelId || 0,
            newCrmActivityChannelName: upsertCrmEventModal.event.newCrmActivityChannelName || "",
            crmActivityResultsId: upsertCrmEventModal.event.crmActivityResultsId || 0,
            newCrmActivityResultName: upsertCrmEventModal.event.newCrmActivityResultName || "",
            eventDate: upsertCrmEventModal.event.eventDate ? 
                (upsertCrmEventModal.event.eventDate instanceof Date ? 
                    moment(upsertCrmEventModal.event.eventDate).format('YYYY-MM-DDTHH:mm:ss') : 
                    moment(upsertCrmEventModal.event.eventDate).format('YYYY-MM-DDTHH:mm:ss')) : null,
            note: upsertCrmEventModal.event.note || "",
            isReminder: upsertCrmEventModal.event.isReminder || false,
            leadManagementId: upsertCrmEventModal.event.leadManagementId || 0,
            personIds: upsertCrmEventModal.event.crmPersonIds || [],
            reminderDateAt: upsertCrmEventModal.event.isReminder && upsertCrmEventModal.event.reminderDateTime ? 
                moment(upsertCrmEventModal.event.reminderDateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            reminderNote: upsertCrmEventModal.event.isReminder ? upsertCrmEventModal.event.reminderNote || "" : "",
            userIds: upsertCrmEventModal.event.isReminder ? upsertCrmEventModal.event.reminderUserIds || [] : []
        }

        request('/CrmManagement/UpsertCrmManagementEvent', {
            method: 'POST',
            data: postData
        }).then((res) => {
            if (res.data.ok) {
                showToast(upsertCrmEventModal.id ? 'Etkinlik Güncellendi' : 'Etkinlik Eklendi', 'success')
                setUpsertCrmEventModal({ open: false, id: null, event: {} })
                getCrmEvents() // Refresh events
                getCrmReminders() // Refresh reminders
                
                // Refresh dropdown lists in case new options were added
                request('/CrmManagement/GetCrmManagementEventTypes', { method: 'GET' })
                    .then(res => {
                        if (res.data.ok) {
                            setActivityTypes(res.data.result.map(type => ({ label: type.name, value: type.id })))
                        }
                    })
                request('/CrmManagement/GetCrmActivityChannels', { method: 'GET' })
                    .then(res => {
                        if (res.data.ok) {
                            setActivityChannels(res.data.result.map(channel => ({ label: channel.name, value: channel.id })))
                        }
                    })
                request('/CrmManagement/GetCrmActivityResults', { method: 'GET' })
                    .then(res => {
                        if (res.data.ok) {
                            setActivityResults(res.data.result.map(result => ({ label: result.name, value: result.id })))
                        }
                    })
            } else {
                showToast('İşlem sırasında hata oluştu', 'error')
            }
        }).catch(error => {
            showToast('İşlem sırasında hata oluştu', 'error')
            console.error('Error saving CRM event:', error)
        })
    }

    return (
        <AnimatedSpan className='page-container d-flex flex-column gap-4'>
            {crmTitle && (
                <div style={{ position: 'relative', width: '100%', top: '-16px', marginBottom: '50px' }}>
                    <div className='card' style={{ position: 'fixed', width: '100%', zIndex: 1, left: 0, borderRadius: 0 }}>
                        <div className='d-flex justify-content-between gap-3'>
                            <div className='row flex-1'>
                                <div className='col-md-6'>
                                    <h1 className='heading-1 text-bold company-title-ellipsis'>{crmTitle}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className='card'>
                {!crmData && <div className='row text-center'>
                    <div className='col-md-12'>
                        <Spinner size={3} />
                    </div>
                </div>}
                {crmData && <>
                    <div className='row'>
                        <div className='col-md-10 col-lg-11 col-xl-11'>
                            <div className='row-margin-x'>
                                <div className='col-lg-8 col-md-6'>
                                    <div className='row-margin-x'>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Kurumsal Adı</label>
                                                <input
                                                    className='default-input'
                                                    type='text'
                                                    name='newCrmCompanyName'
                                                    maxLength={200}
                                                    onChange={handleChange}
                                                    value={crmData.newCrmCompanyName || ''}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Sektör</label>
                                                <Dropdown 
                                                    value={crmData.crmCompanySectorId || crmData.crmCompanySectorName}
                                                    onChange={e => {
                                                        if (!e.originalEvent) return
                                                        let isId = Number.isInteger(e.value) && sectors.find(s => s.value === e.value)
                                                        setCrmData((prev) => ({
                                                            ...prev,
                                                            crmCompanySectorId: isId ? e.value : null,
                                                            crmCompanySectorName: isId ? null : e.value
                                                        }))
                                                    }}
                                                    onInput={e => {
                                                        setCrmData((prev) => ({ 
                                                            ...prev, 
                                                            crmCompanySectorId: null, 
                                                            crmCompanySectorName: e.target.value 
                                                        }))
                                                    }}
                                                    options={sectors}
                                                    optionLabel='label'
                                                    optionValue='value'
                                                    filter
                                                    filterLocale='tr'
                                                    editable
                                                    filterInputAutoFocus={false}
                                                    className={'w-100'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row-margin-x mt-3'>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Hizmet Sağlayıcı</label>
                                                <Dropdown
                                                    value={crmData.serviceProvider ?? 0}
                                                    onChange={(e) => handleChange(e.value, 'serviceProvider')}
                                                    options={[
                                                        { label: 'Nuevo', value: 0 },
                                                        { label: 'Odito', value: 1 }
                                                    ]}
                                                    optionLabel='label'
                                                    optionValue='value'
                                                    className='w-100'
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>
                                                    Web Sitesi
                                                    {crmData.webSiteUrl && (
                                                        <a 
                                                            href={crmData.webSiteUrl} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={{ marginLeft: '10px', fontSize: '12px', color: '#007bff' }}
                                                        >
                                                            Siteye Git
                                                        </a>
                                                    )}
                                                </label>
                                                <input
                                                    className='default-input'
                                                    type='url'
                                                    name='webSiteUrl'
                                                    onChange={handleChange}
                                                    value={crmData.webSiteUrl || ''}
                                                    placeholder='https://www.ornek.com'
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Account Manager</label>
                                                <DefaultSelect
                                                    isMulti
                                                    handleChange={(e) => handleChange(e ? e.map(am => am.value) : [], 'accountManagerUserIds')}
                                                    selectOptions={accountManagers}
                                                    value={crmData.accountManagerUserIds ?
                                                        accountManagers.filter(am => crmData.accountManagerUserIds.includes(am.value)) : []}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-6'>
                                    <div className='form-control'>
                                        <div className='form-control-label'>Durum</div>
                                        <Dropdown
                                            value={crmData.status}
                                            onChange={(e) => handleChange(e.value, 'status')}
                                            options={[
                                                { label: 'Pasif', value: 0 },
                                                { label: 'Aktif', value: 1 }
                                            ]}
                                            optionLabel='label'
                                            optionValue='value'
                                            className={'w-100'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-2 col-lg-1 col-xl-1 d-flex px-md-0 flex-column align-items-end'>
                            <Button title='Güncelle' handleClick={handleSave} className='btn-success w-100 d-flex justify-content-center mt-4' />
                            <Button title='Sil' handleClick={handleDelete} className='btn-danger w-100 d-flex justify-content-center mt-3' />
                        </div>
                    </div>
                </>
                }
            </div>
            <AccordionComp title='Kişiler' className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            header={
                                <div className='d-flex justify-content-between align-items-center gap-3'>
                                    <div className='row flex-1'>
                                        <div className='col-md-4'>
                                            <span className='d-flex align-items-center gap-2'>
                                                <Icons.search size={18} />
                                                <input
                                                    className='default-input'
                                                    placeholder='Ad Soyad Ara...'
                                                    value={contactFilters.name}
                                                    onChange={(e) => setContactFilters(prev => ({ ...prev, name: e.target.value }))}
                                                />
                                            </span>
                                        </div>
                                        <div className='col-md-4'>
                                            <DefaultSelect
                                                handleChange={(e) => setContactFilters(prev => ({ ...prev, department: e }))}
                                                value={contactFilters.department}
                                                placeholder='Departman'
                                                isSearchable
                                                isClearable
                                                selectOptions={departments}
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <DefaultSelect
                                                handleChange={(e) => setContactFilters(prev => ({ ...prev, position: e }))}
                                                value={contactFilters.position}
                                                placeholder='Pozisyon'
                                                isSearchable
                                                isClearable
                                                selectOptions={positions}
                                            />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-end'>
                                        {getPermission('CrmManagement.update') && <Button className='btn-primary btn-sm' title='Kişi Ekle' handleClick={() => setUpsertCrmContactModal({ open: true, id: null, person: {} })} icon={<Icons.plus />} />}
                                    </div>
                                </div>
                            }
                            paginator
                            alwaysShowPaginator={true}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={filteredCrmContacts}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                            onRowClick={e => {
                                if (e.originalEvent.target.className.includes('p-button-icon')) return
                                if (getPermission('CrmManagement.update') && e.data.id) {
                                    setUpsertCrmContactModal({ open: true, id: e.data.id, person: e.data })
                                }
                            }}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='firsName'
                                style={{ width: 'auto' }}
                                header='Ad Soyad'
                                sortable
                                body={(rowData) => `${rowData.firsName} ${rowData.lastName}`}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='mail'
                                style={{ width: 'auto' }}
                                header='E-posta'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='phone'
                                style={{ width: 'auto' }}
                                header='Telefon'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='department'
                                style={{ width: 'auto' }}
                                header='Departman'
                                sortable
                                body={(rowData) => {
                                    const departmentLabel = departments.find(d => d.value === rowData.crmCompanyDepartmentId)?.label || rowData.newCrmCompanyDepartmentName || 'Belirtilmemiş'
                                    return departmentLabel
                                }}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='position'
                                style={{ width: 'auto' }}
                                header='Pozisyon'
                                sortable
                                body={(rowData) => {
                                    const positionLabel = positions.find(p => p.value === rowData.crmCompanyPositionId)?.label || rowData.newCrmCompanyPositionName || 'Belirtilmemiş'
                                    return positionLabel
                                }}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='crmPersonStatus'
                                style={{ width: 'auto' }}
                                header='Durum'
                                sortable
                                body={(rowData) => {
                                    let statusLabel = 'Aktif'
                                    let statusClass = 'text-success'
                                    
                                    if (rowData.crmPersonStatus === 1) {
                                        statusLabel = 'Ayrıldı'
                                        statusClass = 'text-danger'
                                    }
                                    
                                    return (
                                        <span className={statusClass}>
                                            <strong>{statusLabel}</strong>
                                        </span>
                                    )
                                }}
                            />
                            <Column
                                field='action'
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold pl-0'
                                style={{ width: '7rem' }}
                                body={(rowData) => (
                                    <span className='d-flex gap-1 align-items-center'>
                                        {getPermission('CrmManagement.update') && (
                                            <Icons.refresh
                                                className='text-success cursor-pointer'
                                                style={{fontSize: '1.2rem'}}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setChangeCompanyModal({ open: true, person: rowData });
                                                }}
                                                title="Şirket Değiştir"
                                            />
                                        )}
                                        {getPermission('CrmManagement.update') && (
                                            rowData.crmPersonStatus === 1 ? (
                                                <MdPersonAdd
                                                    className='text-success cursor-pointer'
                                                    style={{fontSize: '1.2rem'}}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePersonStatusChange(rowData, 0);
                                                    }}
                                                    title="İşten Ayrılma Durumunu İptal Et"
                                                />
                                            ) : (
                                                <MdPersonOff
                                                    className='text-warning cursor-pointer'
                                                    style={{fontSize: '1.2rem'}}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePersonStatusChange(rowData, 1);
                                                    }}
                                                    title="İşten Ayrıldı Olarak İşaretle"
                                                />
                                            )
                                        )}
                                        {getPermission('CrmManagement.update') && deleteButton(rowData, '/CRM/DeleteCrmContact', 'contacts')}
                                    </span>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>

            <AccordionComp title='Etkinlikler' className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            header={
                                <div className='d-flex flex-column gap-3'>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div style={{position: 'relative'}} className='form-control'>
                                                <Calendar
                                                    value={eventFilters.dateRange}
                                                    onChange={(e) => setEventFilters(prev => ({ ...prev, dateRange: e.value }))}
                                                    selectionMode="range"
                                                    readOnlyInput
                                                    placeholder="Etkinlik tarih aralığı..."
                                                    showIcon
                                                    dateFormat="dd/mm/yy"
                                                    className="w-100"
                                                />
                                                {eventFilters.dateRange && eventFilters.dateRange.length > 0 && (
                                                    <button 
                                                        type="button"
                                                        onClick={() => setEventFilters(prev => ({ ...prev, dateRange: null }))}
                                                        title="Tarih filtresini temizle"
                                                        style={{
                                                            right: '60px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            background: 'none',
                                                            border: 'none',
                                                            fontSize: '14px',
                                                            color: '#6c757d',
                                                            cursor: 'pointer',
                                                            padding: '2px 4px',
                                                            zIndex: 1000,
                                                            position: 'absolute'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.color = '#dc3545'}
                                                        onMouseLeave={(e) => e.target.style.color = '#6c757d'}
                                                    >
                                                        ✕
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-9'>
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <DefaultSelect
                                                        handleChange={(e) => setEventFilters(prev => ({ ...prev, activityType: e }))}
                                                        value={eventFilters.activityType}
                                                        placeholder='Aksiyon Tipi'
                                                        isSearchable
                                                        isClearable
                                                        selectOptions={activityTypes}
                                                    />
                                                </div>
                                                <div className='col-md-4'>
                                                    <DefaultSelect
                                                        handleChange={(e) => setEventFilters(prev => ({ ...prev, channel: e }))}
                                                        value={eventFilters.channel}
                                                        placeholder='Kanal'
                                                        isSearchable
                                                        isClearable
                                                        selectOptions={activityChannels}
                                                    />
                                                </div>
                                                <div className='col-md-4'>
                                                    <DefaultSelect
                                                        handleChange={(e) => setEventFilters(prev => ({ ...prev, result: e }))}
                                                        value={eventFilters.result}
                                                        placeholder='Sonuç'
                                                        isSearchable
                                                        isClearable
                                                        selectOptions={activityResults}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <DefaultSelect
                                                handleChange={(e) => setEventFilters(prev => ({ ...prev, lead: e }))}
                                                value={eventFilters.lead}
                                                placeholder='İlgili Lead'
                                                isSearchable
                                                selectOptions={leadManagements || []}
                                                isClearable
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <DefaultSelect
                                                handleChange={(e) => setEventFilters(prev => ({ ...prev, accountManager: e || [] }))}
                                                value={eventFilters.accountManager}
                                                placeholder='Kişi Seçin'
                                                isSearchable
                                                isMulti
                                                isClearable
                                                selectOptions={crmContacts.map(contact => ({ 
                                                    label: `${contact.firsName} ${contact.lastName}`, 
                                                    value: contact.id 
                                                }))}
                                            />
                                        </div>
                                        <div className='col-md-3 d-flex justify-content-end'>
                                            {getPermission('CrmManagement.update') && <Button className='btn-primary btn-sm' title='Etkinlik Ekle' handleClick={() => setUpsertCrmEventModal({ open: true, id: null, event: {} })} icon={<Icons.plus />} />}
                                        </div>
                                    </div>
                                </div>
                            }
                            paginator
                            alwaysShowPaginator={true}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={filteredCrmEvents}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                            onRowClick={e => {
                                if (e.originalEvent.target.className.includes('p-button-icon')) return
                                if (getPermission('CrmManagement.update') && e.data.id) {
                                    setUpsertCrmEventModal({ open: true, id: e.data.id, event: e.data })
                                }
                            }}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='eventDate'
                                style={{ width: 'auto' }}
                                header='Etkinlik Tarihi'
                                sortable
                                body={(rowData) => rowData.eventDate && moment(rowData.eventDate).format('DD/MM/YYYY HH:mm')}
                            />
                              <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='leadManagement.projectName'
                                style={{ width: 'auto' }}
                                header='İlgili Lead'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='activityType'
                                style={{ width: 'auto' }}
                                header='Aksiyon Tipi'
                                sortable
                                body={(rowData) => {
                                    if (rowData.crmManagementActivityTypeId) {
                                        const activityType = activityTypes.find(t => t.value === rowData.crmManagementActivityTypeId)
                                        return activityType ? activityType.label : 'Belirtilmemiş'
                                    }
                                    return rowData.newCrmManagementActivityTypeName || 'Belirtilmemiş'
                                }}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='channel'
                                style={{ width: 'auto' }}
                                header='Kanal'
                                sortable
                                body={(rowData) => {
                                    if (rowData.crmActivityChannelId) {
                                        const channel = activityChannels.find(c => c.value === rowData.crmActivityChannelId)
                                        return channel ? channel.label : 'Belirtilmemiş'
                                    }
                                    return rowData.newCrmActivityChannelName || 'Belirtilmemiş'
                                }}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='result'
                                style={{ width: 'auto' }}
                                header='Etkinlik Sonucu'
                                sortable
                                body={(rowData) => {
                                    if (rowData.crmActivityResultsId) {
                                        const result = activityResults.find(r => r.value === rowData.crmActivityResultsId)
                                        return result ? result.label : 'Belirtilmemiş'
                                    }
                                    return rowData.newCrmActivityResultName || 'Belirtilmemiş'
                                }}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                field='note'
                                style={{ width: '300px', maxWidth: '100%' }}
                                header='Not'
                                sortable
                                body={(rowData) => rowData.note && (
                                    <span 
                                        dangerouslySetInnerHTML={{ __html: rowData.note }} 
                                        className='scroll-note' 
                                        style={{ 
                                            maxWidth: '100%', 
                                            padding: '5px', 
                                            margin: '0',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            lineHeight: '1.2em',
                                            maxHeight: '2.6em'
                                        }}
                                    />
                                )}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='isReminder'
                                style={{ width: 'auto' }}
                                header='Hatırlatıcı'
                                sortable
                                body={(rowData) => (
                                    <span className={rowData.isReminder ? 'text-success' : 'text-muted'}>
                                        <strong>{rowData.isReminder ? 'Var' : 'Yok'}</strong>
                                    </span>
                                )}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='persons'
                                style={{ width: 'auto' }}
                                header='Kişiler'
                                sortable
                                body={(rowData) => {
                                    if (rowData.crmPersonIds && rowData.crmPersonIds.length > 0) {
                                        const personNames = rowData.crmPersonIds.map(personId => {
                                            const person = crmContacts.find(contact => contact.id === personId)
                                            return person ? `${person.firsName} ${person.lastName}` : 'Bilinmeyen'
                                        })
                                        return personNames.join(', ')
                                    }
                                    return 'Seçilmemiş'
                                }}
                            />
                            <Column
                                field='action'
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold pl-0'
                                style={{ width: '2.5rem' }}
                                body={(rowData) => (
                                    <span className='d-flex gap-1'>
                                        {getPermission('CrmManagement.update') && deleteButton(rowData, '/CRM/DeleteCrmEvent', 'events')}
                                    </span>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>

            <AccordionComp title='Hatırlatıcılar' className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            header={
                                <div className='d-flex justify-content-between align-items-center gap-3'>
                                    <div className='row flex-1'>
                                        <div className='col-md-3'>
                                            <div style={{position: 'relative'}} className='form-control'>
                                                <Calendar
                                                    value={reminderFilters.dateRange}
                                                    onChange={(e) => setReminderFilters(prev => ({ ...prev, dateRange: e.value }))}
                                                    selectionMode="range"
                                                    readOnlyInput
                                                    placeholder="Tarih aralığı seçin..."
                                                    showIcon
                                                    dateFormat="dd/mm/yy"
                                                    className="w-100"
                                                />
                                                {reminderFilters.dateRange && reminderFilters.dateRange.length > 0 && (
                                                    <button 
                                                        type="button"
                                                        onClick={() => setReminderFilters(prev => ({ ...prev, dateRange: null }))}
                                                        title="Tarih filtresini temizle"
                                                        style={{
                                                            right: '60px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            background: 'none',
                                                            border: 'none',
                                                            fontSize: '14px',
                                                            color: '#6c757d',
                                                            cursor: 'pointer',
                                                            padding: '2px 4px',
                                                            zIndex: 1000,
                                                            position: 'absolute'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.color = '#dc3545'}
                                                        onMouseLeave={(e) => e.target.style.color = '#6c757d'}
                                                    >
                                                        ✕
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <DefaultSelect
                                                handleChange={(e) => setReminderFilters(prev => ({ ...prev, status: e }))}
                                                value={reminderFilters.status}
                                                placeholder='Durum'
                                                isSearchable
                                                isClearable
                                                selectOptions={[
                                                    { label: 'Done', value: 1 },
                                                    { label: 'Not Done', value: 0 }
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-end'>
                                        {getPermission('CrmManagement.update') && <Button className='btn-primary btn-sm' title='Hatırlatıcı Ekle' handleClick={() => {
                                            const currentUserId = userInfo ? userInfo['jti'] : null;
                                            setUpsertCrmReminderModal({ 
                                                open: true, 
                                                id: null, 
                                                reminder: currentUserId ? { userIds: [Number(currentUserId)] } : {} 
                                            })
                                        }} icon={<Icons.plus />} />}
                                    </div>
                                </div>
                            }
                            paginator
                            alwaysShowPaginator={true}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={filteredCrmReminders}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                            onRowClick={e => {
                                if (e.originalEvent.target.className.includes('p-button-icon')) return
                                if (getPermission('CrmManagement.update') && e.data.id) {
                                    setUpsertCrmReminderModal({ open: true, id: e.data.id, reminder: {...e.data,userIds:e.data?.users?.map(u => u.id) || []} })
                                }
                            }}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='dateAt'
                                style={{ width: 'auto' }}
                                header='Hatırlatıcı Tarihi'
                                sortable
                                body={(rowData) => rowData.dateAt && moment(rowData.dateAt).format('DD/MM/YYYY HH:mm')}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='userIds'
                                style={{ width: 'auto' }}
                                header='İlgili Kişiler'
                                body={(rowData) => {
                                    if (rowData.users && rowData.users.length > 0) {
                                        const userNames = rowData.users
                                            .map(user => (`${user.firstName} ${user.lastName}`))
                                            .join(', ');
                                        return userNames || '-';
                                    }
                                    return '-';
                                }}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='note'
                                style={{ maxWidth: '300px' }}
                                header='Hatırlatıcı Notu'
                                body={(rowData) => rowData.note && (
                                    <span 
                                        style={{ 
                                            maxWidth: '100%', 
                                            padding: '5px', 
                                            margin: '0',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            lineHeight: '1.2em',
                                            maxHeight: '2.6em'
                                        }}
                                    >
                                        {rowData.note}
                                    </span>
                                ) || '-'}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='crmReminderStatus'
                                style={{ width: 'auto' }}
                                header='Durum'
                                body={(rowData) => (
                                    <span className={rowData.crmReminderStatus === 1 ? 'text-success' : 'text-warning'}>
                                        <strong>{rowData.crmReminderStatus === 1 ? 'Done' : 'Not Done'}</strong>
                                    </span>
                                )}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='crmManagementEventId'
                                style={{ width: 'auto' }}
                                header='İlgili Etkinlik'
                                body={(rowData) => {
                                    if (rowData.crmManagementEventId) {
                                        // Find the event in crmEvents to get its details
                                        const relatedEvent = crmEvents.find(event => event.id === rowData.crmManagementEventId);
                                        if (relatedEvent) {
                                            const eventDate = moment(relatedEvent.eventDate).format('DD/MM/YYYY')
                                            const projectName = relatedEvent?.leadManagement?.projectName || 'İlgili Lead Yok'
                                            const activityType = relatedEvent.crmManagementActivityTypeName || 
                                                               relatedEvent.newCrmManagementActivityTypeName || 
                                                               'Etkinlik'
                                            return `${eventDate} - ${projectName} - ${activityType}`
                                        }
                                    }
                                    return '-';
                                }}
                            />
                            <Column
                                field='action'
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold pl-0'
                                style={{ width: '5rem' }}
                                body={(rowData) => (
                                    <span className='d-flex gap-1 align-items-center'>
                                        {getPermission('CrmManagement.update') && (
                                            rowData.crmReminderStatus === 1 ? (
                                                <MdCheckCircle
                                                    className='text-success cursor-pointer'
                                                    style={{fontSize: '1.2rem'}}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleReminderStatusChange(rowData, 0);
                                                    }}
                                                    title="Not Done Olarak İşaretle"
                                                />
                                            ) : (
                                                <MdRadioButtonUnchecked
                                                    className='text-warning cursor-pointer'
                                                    style={{fontSize: '1.2rem'}}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleReminderStatusChange(rowData, 1);
                                                    }}
                                                    title="Done Olarak İşaretle"
                                                />
                                            )
                                        )}
                                        {getPermission('CrmManagement.update') && deleteButton(rowData, '/CrmManagement/DeleteCrmReminder', 'reminders')}
                                    </span>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>

            <AccordionComp title='Leads' className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            paginator
                            alwaysShowPaginator={true}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={crmLeads}
                            onRowClick={e => {
                                navigate(`/lead-management/${e.data.id}`)
                            }}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='projectName'
                                style={{ width: '35%' }}
                                header='Proje Adı'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='projectDescription'
                                style={{ width: '35%', maxWidth: '400px',whiteSpace: 'nowrap' ,overflow: 'hidden',textOverflow: 'ellipsis' }}
                                header='Lead Açıklaması'
                                body={(rowData) => rowData.projectDescription || '-'}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='offerDate'
                                style={{ width: '15%' }}
                                header='Tarih'
                                sortable
                                body={(rowData) => rowData.createdAt && moment(rowData.createdAt).format('DD/MM/YYYY')}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='status'
                                style={{ width: '15%' }}
                                header='Durum'
                                sortable
                                body={(rowData) => {
                                    // Lead status mapping - Constants.js'den leadManagementStatus kullanılıyor
                                    const statusMap = {
                                        0: leadManagementStatus.new.label,
                                        1: leadManagementStatus.preparingScope.label,
                                        2: leadManagementStatus.waitingEffort.label,
                                        3: leadManagementStatus.effortGiven.label,
                                        4: leadManagementStatus.offerGiven.label,
                                        5: leadManagementStatus.revisionRequested.label,
                                        6: leadManagementStatus.approved.label,
                                        7: leadManagementStatus.suspended.label,
                                        8: leadManagementStatus.rejected.label
                                    }
                                    return statusMap[rowData.status] || `Durum ${rowData.status}`;
                                }}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>
          

            <Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
                <ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleApprovalModalApproved} />
            </Dialog>
            <Dialog style={{ width: '800px', maxWidth: '100%' }} draggable={false} header={upsertCrmEventModal.id ? 'Etkinlik Düzenle' : 'Etkinlik Ekle'} visible={upsertCrmEventModal.open} onHide={() => setUpsertCrmEventModal({ open: false, id: null, event: {} })}>
                <CrmEventModal 
                    event={upsertCrmEventModal.event}
                    activityTypes={activityTypes}
                    activityChannels={activityChannels}
                    activityResults={activityResults}
                    leadManagements={leadManagements}
                    crmContacts={crmContacts}
                    users={users?.filter(r => r?.roles?.map(r => r.id).includes(roleIds.accountManager) || r?.roles?.map(r => r.id).includes(roleIds.projectManager) || r?.roles?.map(r => r.id).includes(roleIds.admin))}
                    onEventChange={(event) => setUpsertCrmEventModal(prev => ({ ...prev, event }))}
                    onSave={handleAddCrmEvent}
                    onCancel={() => setUpsertCrmEventModal({ open: false, id: null, event: {} })}
                    isEdit={!!upsertCrmEventModal.id}
                />
            </Dialog>
            <Dialog style={{ width: '600px', maxWidth: '100%' }} draggable={false} header={upsertCrmContactModal.id ? 'Kişi Düzenle' : 'Kişi Ekle'} visible={upsertCrmContactModal.open} onHide={() => setUpsertCrmContactModal({ open: false, id: null, person: {} })}>
                <CrmPersonModal 
                    person={upsertCrmContactModal.person}
                    departments={departments}
                    positions={positions}
                    onPersonChange={(person) => setUpsertCrmContactModal(prev => ({ ...prev, person }))}
                    onSave={handleAddCrmPerson}
                    onCancel={() => setUpsertCrmContactModal({ open: false, id: null, person: {} })}
                    isEdit={!!upsertCrmContactModal.id}
                />
            </Dialog>
            <Dialog style={{ width: '600px', maxWidth: '100%' }} draggable={false} header={upsertCrmReminderModal.id ? 'Hatırlatıcı Düzenle' : 'Hatırlatıcı Ekle'} visible={upsertCrmReminderModal.open} onHide={() => setUpsertCrmReminderModal({ open: false, id: null, reminder: {} })}>
                <CrmReminderModal 
                    reminder={upsertCrmReminderModal.reminder}
                    crmEvents={crmEvents}
                    users={users?.filter(r => r?.roles?.map(r => r.id).includes(roleIds.accountManager) || r?.roles?.map(r => r.id).includes(roleIds.projectManager) || r?.roles?.map(r => r.id).includes(roleIds.admin) )}
                    onReminderChange={(reminder) => setUpsertCrmReminderModal(prev => ({ ...prev, reminder }))}
                    onSave={handleAddCrmReminder}
                    onCancel={() => setUpsertCrmReminderModal({ open: false, id: null, reminder: {} })}
                    isEdit={!!upsertCrmReminderModal.id}
                />
            </Dialog>
            <Dialog style={{ width: '500px', maxWidth: '100%' }} draggable={false} header='Şirket Değiştir' visible={changeCompanyModal.open} onHide={() => setChangeCompanyModal({ open: false, person: null })}>
                <ChangeCompanyModal 
                    person={changeCompanyModal.person}
                    companies={allCrmCompanies}
                    onSave={handleChangeCompany}
                    onCancel={() => setChangeCompanyModal({ open: false, person: null })}
                />
            </Dialog>
        </AnimatedSpan>
    )
}
export default CrmDetail
